<script setup>
import config from '@/common/config'
import { get, post, qsela, serverDt } from '@/common/util'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import _ from 'lodash-es'
import { reactive } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
const baseUrl = import.meta.env.BASE_URL;
const emit=defineEmits(['onClose']), meta=reactive({loading:true,menus:['announcements','termsofuse','privacypolicy','locationterms'],selmenu:'root',notices:{fixedrows:[],rows:[]}
  ,notisearch:{sortcol:'cdt',dtcol:'sdt',isasc:false,page:1,size:20,where:{enabled_eq_:true,fixed_eq_:false}}}),metaStore=useMetaStore()
,sel=async(menu)=>{
  meta.selmenu=menu
  meta.terms=[]
  meta.selterms={}
  meta.notices={fixedrows:[],rows:[]}
  if(menu=='announcements')initNoti()
  else initTerms(menu)
},detailBack=async()=>{
  if(meta.selmenu=='announcements'){
    if(meta.selnoti)meta.selnoti=null
    else sel('root')
  }else sel('root')
},initTerms=async(menu)=>{
  meta.loading=true
    const res=await get('rest/public/termsofsites/'+menu)
    meta.loading=false
    const current=res.data.filter(term=>term.sdt).find(term=>dayjs(term.sdt).isBefore(dayjs()))
    if(current){
      current.etc='activated'
      meta.selterms=current
    }
    res.data.forEach(term=>{
      term.ttl=metaStore.t(menu)+' '+dayjs(term.sdt).format('YY.MM.DD')+'.'+term.termver
      if(term.etc)term.ttl+=`(${metaStore.t(term.etc)})`
    })
    meta.terms=res.data
},initNoti=async()=>{
  meta.loading=true
  meta.notisearch.dtst=dayjs().subtract(10,'year').toDate()
  meta.notisearch.dtst=serverDt(meta.notisearch.dtst)
  meta.notisearch.dted=serverDt(new Date())
  let res=await post('rest/authed/member/notices',meta.notisearch)
  meta.notices=res.data
  const pd=_.cloneDeep(meta.notisearch)
  pd.where.fixed_eq_=true
  pd.page=1
  pd.size=99999
  res=await post('rest/authed/member/notices',pd)
  meta.notices.fixedrows=res.data.rows
  meta.loading=false
  meta.detailBack=()=>meta.selmenu='root'
},setIfrCont=(ifr,cont)=>{
  if(cont)ifr.contentDocument.body.innerHTML=cont
},init=async()=>{
  meta.loading=true
  meta.cominfos=await get('rest/public/companyinfos')
  meta.cominfos=meta.cominfos.data
  meta.cominfos.forEach(ci=>meta.cominfos[ci.wkey]=ci.sval)
  if(!meta.cominfos.site_nm)meta.cominfos.site_nm='맵오'
  meta.loading=false
  meta.inited=true
}
init()
</script>
<template>
  <div v-if="meta.inited" class="more">
    <v-btn density="compact" variant="text" icon="mdi-close" style="position: absolute;z-index: 1;top: 5px;right: 10px;" @click="emit('onClose')"/>
    <v-card v-if="meta.selmenu=='root'" flat>
      <v-card-title>
        <v-row>
          <v-col cols="1"><img :src="metaStore.logourl" style="max-width: 30px;max-height: 50px;"/></v-col>
          <v-col>{{ meta.cominfos.site_nm }}</v-col>
        </v-row>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-list lines="one" density="compact">
          <v-list-item v-for="menu in meta.menus">
            <v-list-item-title class="cursor-pointer" @click="sel(menu)">{{ $t(menu) }}</v-list-item-title>
            <v-divider class="mt-2" v-if="menu=='announcements'||menu=='locationterms'"/>
          </v-list-item>
        </v-list>
        <v-table class="w-100 text-caption cominfo" density="compact">
          <tbody>
            <tr>
              <td colspan="4">{{ meta.cominfos.com_nm }}</td>
            </tr>
            <tr>
              <th>{{ $t('com_addr') }}</th>
              <td class="cicon">{{ meta.cominfos.com_addr }}</td>
              <th>{{ $t('ceo') }}</th>
              <td class="cicon">{{ meta.cominfos.ceo }}</td>
            </tr>
            <tr>
              <th>{{ $t('business_reg_num') }}</th>
              <td class="cicon">{{ meta.cominfos.business_reg_num }}</td>
              <th>{{ $t('mail_order_number') }}</th>
              <td class="cicon">{{ meta.cominfos.mail_order_number }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
    <v-card v-if="meta.selmenu!='root'" flat min-width="500">
      <v-card-title class="text-center position-relative">
        <v-btn icon="mdi-chevron-left" variant="flat" density="compact" style="position: absolute;left: 5px;" @click="detailBack"/>
        {{ $t(meta.selmenu) }}
      </v-card-title>
      <v-card-text class="cont">
        <div v-if="meta.selmenu=='announcements'">
          <v-table v-if="!meta.selnoti" density="compact">
            <tbody>
              <tr v-for="noti in meta.notices.fixedrows" class="cursor-pointer bg-indigo-lighten-5" @click="meta.selnoti=noti">
                <th>{{ noti.ttl }}</th>
                <td style="width: 30px;"><v-btn icon="mdi-chevron-right" variant="text" density="compact"/></td>
              </tr>
              <tr v-for="noti in meta.notices.rows" class="cursor-pointer" @click="meta.selnoti=noti">
                <th>{{ noti.ttl }}</th>
                <td style="width: 30px;"><v-btn icon="mdi-chevron-right" variant="text" density="compact"/></td>
              </tr>
            </tbody>
          </v-table>
          <!-- <iframe v-else class="conifr" :src="baseUrl+'blank.html'" @load="setIfrCont($event.target,meta.selnoti.cont)"></iframe> -->
          <div v-else class="inquerycontquill ">
            <QuillEditor theme="snow" class="w-100" content-type="html" :content="meta.selnoti.cont" @ready="evt=>{
              qsela('.inquerycontquill .ql-toolbar').forEach(el=>el.remove())
              qsela('.inquerycontquill .ql-editor').forEach(el=>el.contentEditable=false)
              qsela('.inquerycontquill .ql-container').forEach(el=>el.style.borderWidth=0)
            }"/>
          </div>
        </div>
        <!-- <iframe v-else class="conifr" :src="baseUrl+'blank.html'" @load="setIfrCont($event.target,meta.selterms.cont)"></iframe> -->
        <div v-else class="inquerycontquill ">
          <QuillEditor theme="snow" class="w-100" content-type="html" :content="meta.selterms.cont" @ready="evt=>{
            qsela('.inquerycontquill .ql-toolbar').forEach(el=>el.remove())
            qsela('.inquerycontquill .ql-editor').forEach(el=>el.contentEditable=false)
            qsela('.inquerycontquill .ql-container').forEach(el=>el.style.borderWidth=0)
          }"/>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-pagination  density="compact" class="ma-auto" v-if="meta.selmenu=='announcements'&&meta.notices.rows.length" :length="meta.notices.totalPages" :total-visible="meta.notices.pageCount"
          v-model="meta.notisearch.page" @update:model-value="initNoti"/>
          <v-select v-if="meta.terms.length" hide-details variant="outlined" density="compact" :items="meta.terms" :model-value="meta.selterms" item-title="ttl" item-value="id"
            @update:model-value="id=>meta.selterms=meta.terms.find(term=>term.id==id)"/>
        </v-card-actions>
      </v-card>
      <v-overlay contained v-model="meta.loading" class="align-center justify-center" persistent>
        <v-progress-circular color="primary" size="64" indeterminate/>
      </v-overlay>
      <div style="font-size: 12px;margin-left: 30px;color: #333;height: 30px;">Copyright AIGEON Corp. All rights reserved.</div>
  </div>
</template>
<style>
  .more{position: relative;min-width: 450px;}
  .more .cominfo{margin-top: 80px;}
  .more .cominfo th{width: 150px;}
  .more .cominfo .cicon{width: 300px;}
  .more .cominfo * {border: none !important;}
  .more .cont{min-height: 400px;max-width:80vh;max-height: 80vh;overflow-y: auto;}
  .more .inquerycontquill{width: 100%;height: 100%;border-width: 0;min-height: 500px;max-height: 90vh;}
</style>
